import { useCallback, useEffect, useState } from 'react';
import { collaborationService } from '../services/projects/collaboration/collaborationService';
import { isPermissionDenied } from '../utils/grpcErrors';
import { useAccessSettlingRetry } from './useAccessSettlingRetry';
const cache = new Map();
export const useProjectCollaborators = (projectId) => {
    const [collaborators, setCollaborators] = useState(() => { var _a; return projectId ? (_a = cache.get(projectId)) !== null && _a !== void 0 ? _a : [] : []; });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [denied, setDenied] = useState(false);
    const fetchCollaborators = useCallback(async () => {
        if (!projectId) {
            setCollaborators([]);
            return;
        }
        try {
            setIsLoading(true);
            setError(null);
            const response = await collaborationService.list(projectId);
            cache.set(projectId, response.collaborators);
            setCollaborators(response.collaborators);
            setDenied(false);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to load collaborators';
            setError(message);
            setDenied(isPermissionDenied(err));
        }
        finally {
            setIsLoading(false);
        }
    }, [projectId]);
    useAccessSettlingRetry(projectId, denied, fetchCollaborators);
    useEffect(() => {
        if (!projectId) {
            setCollaborators([]);
            return;
        }
        const cached = cache.get(projectId);
        if (cached) {
            setCollaborators(cached);
            return;
        }
        fetchCollaborators();
    }, [projectId, fetchCollaborators]);
    return { collaborators, isLoading, error, refetch: fetchCollaborators };
};
